import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CertificationDoc } from '../_models/certificationDoc';

@Injectable()
export class CertificationDocService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getCertificationDocs(): Observable<CertificationDoc[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/certificationDocs')
      .pipe(map((response) => response));
  }

  getCertificationDoc(id: number): Observable<CertificationDoc> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/certificationDocs/' + id)
      .pipe(map((response) => response));
  }

  saveCertificationDoc(certificationDocItem): Observable<CertificationDoc> {
    const certificationDoc = { ...certificationDocItem };
    delete certificationDoc.lastUpdated;
    delete certificationDoc.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    certificationDoc.companyId = companySelected ? companySelected.id : null;

    if (certificationDoc.user != null && certificationDoc.user.id != null) {
      certificationDoc.user = { id: certificationDoc.user.id };
    }
    if (certificationDoc.id) {
      return this.http
        .put<CertificationDoc>(
          `${this.apiBaseUrl}api/private/v1/certificationDocs/${certificationDoc.id}`,
          certificationDoc
        )
        .pipe(map((response) => response as CertificationDoc));
    } else {
      // Altrimenti, effettua una richiesta POST per creare una nuova certificationDoc
      return this.http
        .post<CertificationDoc>(
          `${this.apiBaseUrl}api/private/v1/certificationDocs/`,
          certificationDoc
        )
        .pipe(map((response) => response as CertificationDoc));
    }
  }

  deleteCertificationDoc(id: number): Observable<CertificationDoc> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/certificationDocs/' + id).pipe(
      map((response) => {
        return { id } as CertificationDoc;
      })
    );
  }
}
